// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  eaId: __t.u64().primaryKey().name("ea_id"),
  kind: __t.string(),
  subject: __t.identity(),
  worldId: __t.u64().name("world_id"),
  action: __t.string(),
  at: __t.timestamp(),
});
